import { Block } from "../types/data";

export const sortingRequirements = (isSort: boolean, data: Block[]): Block[] => {
  if (!isSort) return data;

  return data.map(block => ({
      ...block,
      groupRequirements: [...block.groupRequirements].sort((a, b) => {
          return (b.isFocal === true ? 1 : 0) - (a.isFocal === true ? 1 : 0);
      })
  }));
}
